import { fetcher } from '../utils'
import { ComponentUserToTransferVO, FromProductUserVO } from '@repo/types'

export default async (input: ComponentUserToTransferVO): Promise<FromProductUserVO[]> =>
  fetcher(`/api/transfer/users`, 'POST', input)
